(() => {
  const init = root => {
    if (root.dataset.bookingInit) return;
    root.dataset.bookingInit = 'true';
    const calendar = root.querySelector('[data-rvb-calendar]');
    if (!calendar) return;

    const api = calendar.dataset.api;
    let product = calendar.dataset.product;
    const grid = calendar.querySelector('[data-days]');
    const monthLabel = calendar.querySelector('[data-month]');
    const dateInput = calendar.querySelector('[data-date-input]');
    const formatInput = calendar.querySelector('[data-format-input]');
    const submit = calendar.querySelector('[data-submit]');
    const form = calendar.querySelector('form');
    const productInput = calendar.querySelector('input[name="id"]');
    const selected = calendar.querySelector('[data-selected]');
    const selectedDetail = calendar.querySelector('[data-selected-detail]');
    const status = calendar.querySelector('[data-status]');
    const moreDates = calendar.querySelector('[data-more-dates]');
    const previous = calendar.querySelector('[data-prev]');
    const next = calendar.querySelector('[data-next]');
    const formatButtons = [...calendar.querySelectorAll('[data-format]')];
    const phoneInput = calendar.querySelector('[data-phone-input]');
    const phoneError = calendar.querySelector('[data-phone-error]');
    const phoneTools = window.RevtolBookingPhone;
    if (!phoneInput || !phoneError || !phoneTools) {
      status.hidden = false;
      status.textContent = 'Booking could not be loaded. Please refresh the page and try again.';
      return;
    }
    form.noValidate = true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const firstMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastMonth = new Date(today.getFullYear(), today.getMonth() + 5, 1);
    let cursor = new Date(firstMonth);
    let blocked = new Set();
    let chosen = '';
    let chosenFormat = 'in-person';
    let verified = false;
    let submitting = false;

    const updateSubmitLabel = () => {
      if (!chosen) {
        submit.textContent = 'Choose a date to reserve';
        return;
      }
      submit.textContent = `Reserve · ${calendar.dataset.priceLabel} deposit`;
    };

    const iso = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const rangeUrl = () => {
      const from = new Date(today);
      const to = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0);
      const separator = api.includes('?') ? '&' : '?';
      return `${api}${separator}from=${iso(from)}&to=${iso(to)}`;
    };
    const chooseFormat = format => {
      if (submitting) return;
      const value = format === 'virtual' ? 'virtual' : 'in-person';
      chosenFormat = value;
      formatButtons.forEach(button => {
        const active = button.dataset.format === value;
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-checked', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      formatInput.value = value;
      updateSubmitLabel();
      updateSelectionCopy();
    };

    const updateSelectionCopy = () => {
      if (!chosen) {
        selected.textContent = 'Select an available date';
        selectedDetail.textContent = 'Visits are scheduled Monday through Saturday. Your expected arrival time will be confirmed after booking.';
        return;
      }
      const date = new Date(`${chosen}T12:00:00`);
      selected.textContent = date.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
      selectedDetail.textContent = chosenFormat === 'virtual'
        ? 'Your 45-minute virtual walkthrough time will be confirmed after booking. Weather can affect a live flight demonstration.'
        : 'Your expected arrival time will be confirmed after booking. Wind and weather can require a change.';
    };

    const isSameMonth = (left, right) => left.getFullYear() === right.getFullYear() && left.getMonth() === right.getMonth();

    const render = () => {
      monthLabel.textContent = cursor.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
      previous.disabled = isSameMonth(cursor, firstMonth);
      next.disabled = isSameMonth(cursor, lastMonth);
      grid.innerHTML = '';
      const mondayFirstOffset = (cursor.getDay() + 6) % 7;
      for (let index = 0; index < mondayFirstOffset; index += 1) {
        const blank = document.createElement('span');
        blank.className = 'rvb-calendar__day is-empty';
        grid.append(blank);
      }
      const days = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0).getDate();
      for (let day = 1; day <= days; day += 1) {
        const date = new Date(cursor.getFullYear(), cursor.getMonth(), day);
        const key = iso(date);
        const past = date < today;
        const closed = date.getDay() === 0;
        const unavailable = blocked.has(key);
        const available = verified && !past && !closed && !unavailable;
        const selectedDay = chosen === key;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rvb-calendar__day';
        button.dataset.date = key;
        const dayNumber = document.createElement('span');
        dayNumber.textContent = day;
        button.append(dayNumber);
        const dayStatus = document.createElement('small');
        dayStatus.textContent = selectedDay ? 'Selected' : available ? 'Reserve' : unavailable ? 'Booked' : closed ? 'Closed' : verified ? 'Past' : 'Checking';
        button.append(dayStatus);
        button.classList.toggle('is-available', available);
        button.classList.toggle('is-selected', selectedDay);
        button.classList.toggle('is-closed', closed || past);
        button.classList.toggle('is-unavailable', unavailable);
        button.disabled = !available;
        button.setAttribute('aria-label', `${date.toLocaleDateString(undefined, { dateStyle: 'full' })}, ${dayStatus.textContent.toLowerCase()}`);
        if (available) {
          button.setAttribute('aria-pressed', String(selectedDay));
          button.addEventListener('click', () => {
            if (submitting) return;
            chosen = key;
            dateInput.value = key;
            submit.disabled = !(verified && api && product);
            updateSubmitLabel();
            updateSelectionCopy();
            render();
            grid.querySelector(`[data-date="${key}"]`)?.focus({ preventScroll: true });
          });
        }
        grid.append(button);
      }

      if (moreDates) {
        const hasLaterMonth = !isSameMonth(cursor, lastMonth);
        moreDates.hidden = !hasLaterMonth;
        if (hasLaterMonth) {
          const later = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1);
          moreDates.textContent = `More demo dates in ${later.toLocaleDateString(undefined, { month: 'long' })} →`;
        }
      }
    };

    previous.addEventListener('click', () => {
      if (previous.disabled) return;
      cursor = new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1);
      render();
    });
    next.addEventListener('click', () => {
      if (next.disabled) return;
      cursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1);
      render();
    });
    moreDates?.addEventListener('click', () => next.click());
    formatButtons.forEach(button => {
      button.addEventListener('click', () => chooseFormat(button.dataset.format));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key) || submitting) return;
        event.preventDefault();
        const target = event.key === 'Home' ? formatButtons[0]
          : event.key === 'End' ? formatButtons[formatButtons.length - 1]
            : formatButtons.find(item => item !== button);
        chooseFormat(target.dataset.format);
        target.focus();
      });
    });
    const validatePhone = () => {
      const result = phoneTools.normalize(phoneInput.value);
      phoneError.textContent = result.error || '';
      phoneError.hidden = !result.error;
      phoneInput.setAttribute('aria-invalid', String(Boolean(result.error)));
      return result;
    };
    phoneInput.addEventListener('blur', () => {
      if (phoneInput.value.trim() && validatePhone().number) {
        phoneInput.value = phoneTools.format(phoneInput.value);
      }
    });
    // Shopify/account autofill can contain +1; the fixed prefix is display-only.
    phoneInput.value = phoneTools.format(phoneInput.value);
    phoneInput.addEventListener('input', () => {
      if (phoneInput.getAttribute('aria-invalid') === 'true') {
        phoneError.hidden = true;
        phoneError.textContent = '';
        phoneInput.removeAttribute('aria-invalid');
      }
    });
    chooseFormat(new URLSearchParams(location.search).get('visit'));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!chosen || !verified || !product || submitting) return;
      const contact = validatePhone();
      if (!contact.number) {
        phoneInput.focus();
        return;
      }
      submitting = true;
      submit.disabled = true;
      phoneInput.readOnly = true;
      submit.textContent = 'Adding your visit';
      try {
        status.hidden = false;
        status.textContent = 'Checking your date…';
        const availability = await fetch(rangeUrl(), { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!availability.ok) throw new Error('availability');
        const current = await availability.json();
        if (!Array.isArray(current.blockedDates)) throw new Error('availability');
        if (current.blockedDates.includes(chosen)) {
          blocked = new Set(current.blockedDates);
          chosen = '';
          dateInput.value = '';
          updateSelectionCopy();
          render();
          throw new Error('date_taken');
        }
        status.textContent = 'Adding your visit…';
        const response = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(product), quantity: 1, properties: {
            'Demo date': chosen,
            'Tour format': formatInput.value,
            'Contact phone': contact.number,
            '_revtol_booking_contact': 'phone-v1'
          } }] })
        });
        if (!response.ok) throw new Error();
        location.assign(form.querySelector('input[name="return_to"]').value);
      } catch (error) {
        submitting = false;
        phoneInput.readOnly = false;
        submit.disabled = !chosen;
        updateSubmitLabel();
        status.hidden = false;
        status.textContent = error.message === 'date_taken'
          ? 'That date was just booked. Choose another date; your phone number is still here.'
          : error.message === 'availability'
            ? 'We could not confirm your date. Your details are still here; please try again.'
            : 'The visit could not be added. Your details are still here; please try again or contact the flight team.';
      }
    });

    const resolveProduct = async () => {
      if (/^\d+$/.test(product || '')) return product;
      const handle = calendar.dataset.productHandle;
      if (!handle) return '';
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopRoot}products/${handle}.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) return '';
        const item = await response.json();
        if (item.handle !== handle || item.variants?.length !== 1 || !item.variants[0].available) return '';
        const variant = String(item.variants[0].id || '');
        if (!/^\d+$/.test(variant)) return '';
        calendar.dataset.product = variant;
        productInput.value = variant;
        return variant;
      } catch {
        return '';
      }
    };
    const load = async () => {
      product = await resolveProduct();
      if (!api || !product) {
        status.hidden = false;
        status.textContent = 'Booking is not open yet. The REVTOL availability service and deposit product must be connected in the Theme Editor.';
        render();
        return;
      }
      fetch(rangeUrl(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(response => {
        if (!response.ok) throw Error();
        return response.json();
      })
      .then(data => {
        if (!Array.isArray(data.blockedDates)) throw new Error('availability');
        blocked = new Set(data.blockedDates);
        verified = true;
        if (chosen && blocked.has(chosen)) {
          chosen = '';
          dateInput.value = '';
          submit.disabled = true;
          updateSubmitLabel();
          updateSelectionCopy();
        }
        status.textContent = '';
        status.hidden = true;
        render();
      })
      .catch(() => {
        submit.disabled = true;
        status.hidden = false;
        status.textContent = 'Availability could not be confirmed. Booking is temporarily unavailable.';
      });
    };
    render();
    load();
  };

  document.querySelectorAll('[data-rvb-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    const root = event.target.closest('[data-rvb-root]') || event.target.querySelector?.('[data-rvb-root]');
    if (root) init(root);
  });
})();
